/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">All Groups</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Group Number</th>
                        <th scope="col">Teacher</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(group, index) in groups" :key="group._id">
                        <th>{{group.group}}</th>
                        <td>{{group.teacher_name}}</td>
                        <td>
                            <router-link :to="{ name: 'EditGroup', params : {groupId : group._id} }">
                                <button class="btn btn-primary btn-sm">Edit</button>
                            </router-link>

                            
                            <button class="btn btn-danger btn-sm" @click.prevent="deleteGroup(index)">Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'Group',
    components: {

    },

    data() {
        return {
            groups: [],
            baseUrl: "/groups",
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        deleteGroup(index) {

            let isDelete = confirm("Are you sure to delete this group?");

            if(!isDelete) {
                return;
            }
            
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            axios.get(this.$apiURI + "/groups/" + this.groups[index]._id + "/delete", config)

                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "A group deleted Successfully",
                            type: 'success'
                        })
                        this.groups.splice(index, 1);
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    },
    mounted() {

        this.$toast.open({
            message: "Processing : Loading Levels Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }

        axios.get(this.$apiURI + this.baseUrl, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.groups = response.data.data.groups
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
}
</script>
